/**
 * Stable default export for `@/components/previews` barrels and legacy imports.
 * Implementation lives in `src/features/previews/templates/vcard/VcardPreview.tsx`.
 */

export { VcardTemplate as default } from "@/features/previews/templates/vcard";
